import { getColors } from '../../../../../constants/colors';
import { trpc } from '../../../../../apiCalls/trpcClient';
import React, { useCallback, useMemo } from 'react';
import { StyleSheet, View, Text, Platform, ViewStyle } from 'react-native';
import { TotalCard, ViewType } from './TotalCard';
import { MB_Button } from '@mightybyte/rnw.components.button';
import { quarterSharedStyles } from '../quarter/quarterSharedStyles';
import { DataExport } from '@sapphicsavvy/business';
import { MB_customWindowForWeb } from '@mightybyte/rnw.utils.custom-window-for-web';
import { MB_Table, MB_TableProps } from '@mightybyte/rnw.components.table';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { textStyles } from '../../../../../constants/textStyles';
import {UserVisit} from '@sapphicsavvy/business';

const COLORS = getColors();

const headerTextStyle = mbTextStyles([textStyles.normalText, { color: '#000000', textAlign: 'left' }]);
const headerConatinerStyle: ViewStyle = {
    height: 52,
    justifyContent: 'center',
    paddingRight: 0,
    marginRight: 30,
};

const header: MB_TableProps['header'] = [
    { content: 'Visited page/Action', conatinerStyle: { ...headerConatinerStyle, justifyContent: undefined, minWidth: 200, maxWidth: 200 }, textStyle: headerTextStyle },
    { content: 'Average count', conatinerStyle: { ...headerConatinerStyle, maxWidth: 150, flex: 1}, textStyle: headerTextStyle },
    { content: 'Total count', conatinerStyle: { ...headerConatinerStyle, minWidth: 150, maxWidth: 150 }, textStyle: headerTextStyle },
    { content: 'Unique users count', conatinerStyle: { ...headerConatinerStyle, minWidth: 150, maxWidth: 150 }, textStyle: headerTextStyle },
];

const UserBehavior = () => {
    const {data: userBehaviorStats, isLoading} = trpc.admin.utils.getUserBehavior.useQuery();
    const trpcUtils = trpc.useUtils();

    const data = useMemo(() => {
        const entries = Object.values(UserVisit).map((v)=>v);
        const entryStats = entries.map((entry)=> {
            const statsData = userBehaviorStats?.actionStats.find((item)=> item.actionType === entry);
            return statsData ?? {
                totalCount: 0,
                actionType: entry,
                uniqueUsers: 0,
            };
        });
        const actionsStats = entryStats.map((s)=> {
            const average = s.totalCount / s.uniqueUsers;
            return [
                <Text style={[styles.cellText, {textAlign: 'left'}]} selectable>{s.actionType}</Text>,
                <Text style={styles.cellText}>{isNaN(average) ? 0 : average}</Text>,
                <Text style={styles.cellText}>{s.totalCount}</Text>,
                <Text style={styles.cellText}>{s.uniqueUsers}</Text>,
            ];
        });

        const quarterStats = [[
            <Text style={[styles.cellText, {textAlign: 'left'}]} selectable>Quarters Played</Text>,
            <Text style={styles.cellText}>{userBehaviorStats?.quartersStats?.avgQuartersPerUser?.toFixed(4)}</Text>,
            <Text style={styles.cellText}>{userBehaviorStats?.quartersStats.totalPlayedQuarters}</Text>,
            <Text style={styles.cellText}>{userBehaviorStats?.quartersStats.uniqueUsers}</Text>,
        ]];

        const resultsStats = [[
            <Text style={[styles.cellText, {textAlign: 'left'}]} selectable>Results Views</Text>,
            <Text style={styles.cellText}>{`${userBehaviorStats?.quartersStats?.avgResultsViewsPerQuarter?.toFixed(4)}*`}</Text>,
            <Text style={styles.cellText}>{userBehaviorStats?.quartersStats.totalResultsViews}</Text>,
            <Text style={styles.cellText}>{userBehaviorStats?.quartersStats.uniqueUsers}</Text>,
        ]];

        return [...quarterStats, ...resultsStats, ...actionsStats];
    }, [userBehaviorStats]);


    const downloadHandler = async () => {
        if (Platform.OS === 'web') {
            trpcUtils.admin.utils.exportData.fetch({
                dataType: DataExport.userBehavior,
                filters: {},
            }).then((d) => {
                if (!d) {
                    console.log('No data to download');
                    return;
                }
                MB_customWindowForWeb.open(d.csvUrl, '_blank');
            });
        } else {
            console.log('Download is not supported on this platform');
        }
    };

    const keyExtractor = useCallback((index) =>
    {

        return index.action;
    }, []);

    return (
        <View style={[{backgroundColor: COLORS.white, marginTop: 20}]}>
            <TotalCard viewType={ViewType.USER_BEHAVIOR} rightComponent={
                <MB_Button title={'Download CSV'}
                           onPress={downloadHandler}
                           style={[quarterSharedStyles.button, {width: 200, marginTop: 20}]}
                           textStyle={quarterSharedStyles.buttonText}
                />
            }/>
            <View style={styles.container}>
                <Text style={{marginLeft: 20, marginBottom: 6}}>{'* - average per quarter'}</Text>
                <MB_Table
                    header={header}
                    data={data}
                    headerStyle={styles.tableHeader}
                    rowStyle={styles.rowStyle}
                    style={styles.table}
                    keyExtractor={keyExtractor}
                    loading={isLoading}
                    loadingScreenProps={{ textColor: '#F35E2E' }}
                />
            </View>
        </View>
    );


};

export {UserBehavior};

const styles = StyleSheet.create({
    container: {
        // flexDirection: 'row',
        borderRadius: 15,
        backgroundColor: COLORS.white,
        marginTop: -20,
    },
    table: {
        borderWidth: 0,
    },
    cellText: mbTextStyles([textStyles.smallText, {
        color: '#1E1E1E',
        fontWeight: '400',
        width: '100%',
        textAlign: 'center',
        textTransform: 'capitalize',
    }]),
    tableHeader: {
        height: 50,
        backgroundColor: '#FFF4F0',
        borderBottomWidth: 0,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        marginBottom: -4,
        zIndex: 2,
    },
    rowStyle: {
        height: 68,
        backgroundColor: '#FFFFFF',
        justifyContent: 'center',
    },
});
